const url = process.env.BASE_API_ADDRESS
  ? process.env.BASE_API_ADDRESS
  : "https://api.snapp.ir";
module.exports = {
  LandingServer: `${url}/api/v1/campaign`,
  ServerMedia: `${url}/storage/uploads/`,
  CareerServer: `${url}/api/v1/career`,
  ContactServer: `${url}/api/v1/contact`,
  SmsServer: `${url}/api/v1/sms`,
  DriversServer: `${url}/api/v1/driver`,
  FaqServer: `${url}/api/v1/faq`,
  EducationServer: `${url}/api/v1/education`,
  BanningServer: `${url}/api/v1/banning`,
  GeneralServer: `${url}/api/v1`,
  PromoterServer: "https://promoters.snapp.ir/api/v1",
  GeneralServerV2: `${url}/api/v2`,
};

// "https://api.snapp.ir"
//https://snapp-drivers-laravel-snapp-ode-mozart.apps.private.teh-1.snappcloud.io/



// WEBPACK FOOTER //
// ./src/js/config/ServerConfig.js